<template>
    <v-row justify="center">
        <v-dialog
            v-model="playerNumberDialog"
            :persistent='true'
            width="20%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="startTimeBody">
                <v-card class="cardWrap">
                <CardTitle title="人数選択"/>
                    <v-container>
                        <v-row align="center">
                            <v-col class="text-center" cols="2">人数</v-col>
                            <v-col class="text-center">
                                <v-text-field
                                    v-model="playNumber"
                                    type="number"
                                    />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="onClose">閉じる</v-btn>
                        <v-btn color="primary" text @click="displayChangeOverlay">登録</v-btn>
                    </v-card-actions>
                    <ChangeOverlay
                        page-name="人数"
                        @processing="onNext"
                        @cancel="closeChangeOverLay"
                        :process-result="processing"
                        :OverlaySwitch="changeOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import { utilityMixin } from '@/mixins/utility';
import CardTitle from '@/components/module/CardTitle';
import { CODE_MASTER } from '../../config';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';
import validater from '@/lib/validater';
import {
    UPDATE_PLAY_NUMBER,
    GET_MAX_RESERVE_BRANCH_NO } from '@/constants/reserve';

export default {
    components: {
        CardTitle,
        ChangeOverlay
    },
    props: {
        received: Object,
        playerNumberDialog: Boolean
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            planId: '',
            cellId: '',
            memberNo: '',
            playDate: '',
            groupNum: 0,
            playerMin: 0,
            playerLeft: 0,
            playNumber: 0,
            reserveType: 0,
            oldPlayNumber: 0,
            plan_name: null,
            changeOverlay: false,
            processing: {
                result: '',
                resultText: ''
            }
        };
    },
    methods: {
        /** ----------------------------------------------
         * 予約人数変更
         * ---------------------------------------------- */
        updatePlayerNum () {
            this.checkMaxReserveBranchNo();
            this.$apollo.mutate({
                mutation: UPDATE_PLAY_NUMBER,
                variables: {
                    play_number: this.playNumber,
                    reserve_no: this.reserveNo
                }
            }).then(res => {
                const data = res.data.updatePlayerNumberFromAdmin;
                return data;
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 最大の予約枝番を取得
         * ---------------------------------------------- */
        checkMaxReserveBranchNo () {
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_MAX_RESERVE_BRANCH_NO,
                variables: {
                    reserve_no: this.reserveNo
                }
            }).then(res => {
                const data = res.data.GetReserveBranchNoFromAdmin.reserve_branch_no;
                return data;
            });
        },
        /** ----------------------------------------------
         * 人数変更時の最低人数チェック
         * @people 入力された変更人数
         * ---------------------------------------------- */
        checkPeopleNumber (people) {
            let maxPeople = this.groupNum * this.playerMax;
            let minPeople = this.playerMin * this.groupNum;
            // 通常要予約の場合
            if (this.reserveType === Number(CODE_MASTER.RESERVE_TYPE_NORMAL)) {
                // 最大予約人数より多くないか
                if (maxPeople < people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.playermax'));
                    return false;
                // 最小予約人数より少ないか
                } else if (minPeople > people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.playermin'));
                    return false;
                // もとの人数より変わっているか
                } else if (this.oldPlayNumber === people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.nochange'));
                    return false;
                // 半角数字じゃなければ
                } else if (!validater.checkIntType(people)) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.stringinttype'));
                    return false;
                // 問題無ければ
                } else {
                    this.$set(this.processing, 'result', '');
                    this.$set(this.processing, 'resultText', '');
                    return true;
                }
            } else if (Number(this.reserveType) === Number(CODE_MASTER.RESERVE_TYPE_REQUEST)) {
                // 最大予約人数より多くないか
                if (maxPeople < people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.playermax'));
                    return false;
                // 最小予約人数より少ないか
                } else if (minPeople > people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.playermin'));
                    return false;
                // もとの人数より変わっているか
                } else if (this.oldPlayNumber === people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.nochange'));
                    return false;
                // 半角数字じゃなければ
                } else if (!validater.checkIntType(people)) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.stringinttype'));
                    return false;
                // 問題無ければ
                } else {
                    this.$set(this.processing, 'result', '');
                    this.$set(this.processing, 'resultText', '');
                    return true;
                }
            // 一人予約の場合
            } else {
                let diffPeople = this.oldPlayNumber - people;
                // 0より多いか
                if (people <= 0) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.playermin'));
                    return false;
                // 半角数字じゃなければ
                } else if (!validater.checkIntType(people)) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.stringinttype'));
                    return false;
                // もとの人数より変わっているか
                } else if (this.oldPlayNumber === people) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.nochange'));
                    return false;
                // 予約可能な人数を超えていれば
                } else if ((this.playerLeft + diffPeople) < 0) {
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', this.$t('error.validation.number.playerover'));
                    return false;
                // 問題無ければ
                } else {
                    this.$set(this.processing, 'result', '');
                    this.$set(this.processing, 'resultText', '');
                    return true;
                }
            }
        },
        /** ----------------------------------------------
         * 次へボタン処理
         * ---------------------------------------------- */
        async onNext () {
            this.message = await this.checkDialogNumber();
            if (this.message) {
                this.closeChangeOverLay();
                // リクエスト予約でセルIDを登録していない場合、同伴者画面を表示しない
                if (Number(this.cellId) === 0 && Number(this.reserveType) === 3) {
                    this.$emit('num-only-update');
                    return;
                }
                this.$emit('open-companion', this.reserveNo);
            }
        },
        /** ----------------------------------------------
         * ダイアログ画面から人数を変更選択した時の処理
         * ---------------------------------------------- */
        checkDialogNumber () {
            // 入力された人数が正しいかチェックしてメッセージを渡す
            if (this.checkPeopleNumber(this.playNumber)) {
                this.updatePlayerNum();
                return this.$t('message.changeNumber');
            }
        },
        /** ----------------------------------------------
         * この画面を開く処理
         * ---------------------------------------------- */
        ModalControl (reserveNo, playNumber, groupNum, playerMin, reserveType, playerLeft, playerMax, cellId) {
            this.reserveNo = reserveNo;
            this.oldPlayNumber = playNumber;
            this.playNumber = playNumber;
            this.groupNum = groupNum;
            this.playerMin = playerMin;
            this.playerMax = playerMax;
            this.reserveType = reserveType;
            this.playerLeft = playerLeft;
            this.cellId = cellId;
        },
        /** ----------------------------------------------
         * 変更ダイアログを開く処理
         * ---------------------------------------------- */
        displayChangeOverlay () {
            this.changeOverlay = true;
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる処理
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.$set(this.processing, 'result', '');
            this.$set(this.processing, 'resultText', '');
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * 閉じるボタン処理
         * ---------------------------------------------- */
        onClose () {
            this.$emit('close');
        }
    }
};
</script>
